document.addEventListener('DOMContentLoaded', function() {
    let checkGiftInterval;
    function checkGiftCardAndRegularItems(variantId) {
        fetch('/cart.js').then(response => response.json()).then(cart => {
            let hasGiftCard = false;
            let hasRegularItem = false;
            let button  = document.getElementById(`btn-${variantId}`);
            let sideCartDrawerBody = document.querySelector('.side-cart__drawer-body');
            cart.items.forEach(function(item) {
                if (item.gift_card) {
                    hasGiftCard = true;
                } else {
                    hasRegularItem = true;
                }
            });
            // console.log('hasGiftCard', hasGiftCard)
            // console.log('hasRegularItem', hasRegularItem)
            if (hasGiftCard && !hasRegularItem) sideCartDrawerBody.classList.add('hide-upsells');
            if (!hasGiftCard && hasRegularItem) sideCartDrawerBody.classList.remove('hide-upsells');
            if (hasGiftCard && hasRegularItem) {
                let selector = document.querySelector(".side-cart__drawer-items");
                console.log('You cannot purchase a gift card along with regular items.');
                if (selector) {
                    const existingErrorMessage = document.querySelector('.error-warning');
                    if (!existingErrorMessage) {
                        const errorMessage = document.createElement('div');
                        errorMessage.classList.add('error-warning');
                        errorMessage.textContent = "You cannot purchase a gift card along with other regular items.";
                        selector.parentNode.insertBefore(errorMessage, selector.nextSibling);
                    }
                }
                if (button) button.click();
            }
        }).catch(error => {
            console.error('Error fetching cart data:', error);
        });
        
        clearInterval(checkGiftInterval);
    }
    document.body.addEventListener('click', function(event) {
        if (event.target && event.target.hasAttribute('data-custom-add-to-cart')) {
            var variantId = event.target.getAttribute('data-add-item-id');
            checkGiftInterval = setInterval(() => checkGiftCardAndRegularItems(variantId), 1000);
        }
    });
});